import React from "react";
import Modal from "react-modal";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  modalCallbacksAtom,
  modalComponentAtom,
  modalExtraDataAtom,
  modalLoadingAtom,
  modalOpenAtom,
} from "./atoms";
// import { EntityForm } from "../Form/EntityForm";
import componentLookup from "./resolver";

import { FaTimes } from "react-icons/fa";
import classNames from "classnames";

import "./modal.scss";

export default function ModalHandler(props) {
  // const [strictlyForm, setStrictlyForm] = useState(false);
  // const [extraData, setExtraData] = useState(false);

  const [isModalOpen, setIsModalOpen] = useRecoilState(modalOpenAtom);
  const [modalLoading, setModalLoading] = useRecoilState(modalLoadingAtom);
  const [modalComponent, setModalComponent] =
    useRecoilState(modalComponentAtom);
  const [modalExtraData, setModalExtraData] =
    useRecoilState(modalExtraDataAtom);
  const modalCallbacks = useRecoilValue(modalCallbacksAtom);

  const closeModal = () => {
    setIsModalOpen(!isModalOpen);
    setModalLoading(false);
  };

  const Component = componentLookup(modalComponent);
  const formRowClasses = classNames("entity-modal-form", {
    [`entity-modal-form-appdocs`]:
      modalComponent === "addApplicationDocumentsModal" ? true : false,
    [`entity-modal-form-addnl-worksites`]: false,
    [`entity-modal-form-create-group`]:
      modalComponent === "createGroupModal" ? true : false,
    [`entity-modal-form-appxc`]: false,
  });

  const inputRowClasses = classNames("modal-frame", {
    [`addApplicationDocumentsModal`]:
      modalComponent === "addApplicationDocumentsModal" ? true : false,
    [`add-addnl-worksites`]: false,
    [`add-appxC`]: false,
  });

  return (
    <Modal
      className={modalComponent === "createGroupModal" ? formRowClasses : ""}
      isOpen={isModalOpen}
      contentLabel="Minimal Modal Example"
      onRequestClose={closeModal}
      overlayClassName="Entity-Overlay"
    >
      <div className={inputRowClasses}>
        <button className="modal-empty-button modal-close" onClick={closeModal}>
          <FaTimes size={"2em"} />
          <span className="usa-sr-only">Close modal</span>
        </button>
        <Component
          {...props}
          closeModal={closeModal}
          callbacks={modalCallbacks}
          extraData={modalExtraData}
        />
      </div>
    </Modal>
  );
}
